import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { isImageDeviation } from '../../DeviationViews/_helpers';
import Dumbo from '../../DeviationViews/Dumbo';
import s from './SystemNotificationIcon.scss';
var ICON_DESKTOP_SIZE = 50;
var ICON_MOBILE_SIZE = 77;
// C96
export var SystemNotificationIcon = function (_a) {
    var IconComponent = _a.iconComponent, backgroundDeviation = _a.backgroundDeviation;
    var isMobile = useContext(MobileContext);
    var iconSize = isMobile ? ICON_MOBILE_SIZE : ICON_DESKTOP_SIZE;
    var hasBackground = backgroundDeviation && isImageDeviation(backgroundDeviation);
    return (React.createElement("div", { className: classnames(s['root'], !hasBackground && s['empty-background']) },
        hasBackground && backgroundDeviation && (React.createElement(React.Fragment, null,
            React.createElement(Dumbo, { className: s['thumb'], deviation: backgroundDeviation, width: iconSize, height: iconSize }),
            React.createElement("div", { className: s['overlay'] }))),
        React.createElement(IconComponent, { className: s['icon'], customSizable: true })));
};
SystemNotificationIcon.displayName = 'SystemNotificationIcon';
export default SystemNotificationIcon;
//# sourceMappingURL=SystemNotificationIcon.js.map